const withStopPropagation = handler => event => {
    event.stopPropagation();
    handler();
};

export default withStopPropagation;
